export default {
  gtmCode: ['P3HFT6F'], // 可放置多個
}
